import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstance1u01li7150917 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancedviv089p54f2 as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAllc6188g3y1sqz as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpNetworkTransport$execute$slambda$o$collect$slambda($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  return constructCallableReference(function *(value, $completion) {
    var $this$transform = $$this$unsafeFlow;
    var tmp$ret$1 = withHttpInfo(this$0, value, $request.t40_1, $httpResponse, $millisStart);
    yield* $this$transform.v1d(tmp$ret$1, $completion);
    return Unit_instance;
  }, 1);
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
  return constructCallableReference(function *(value, $completion) {
    var tmp0 = $$this$unsafeFlow;
    $l$block: {
      var tmp;
      if (isInterface($operation, Subscription())) {
        // Inline function 'kotlin.apply' call
        var this_0 = jsonReader_0(value);
        var tmp0_elvis_lhs = $request.e41_1;
        this_0.q4c(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
        var reader = this_0;
        var payloadResponse = null;
        var errors = null;
        reader.f3y();
        while (reader.q1()) {
          switch (reader.h3y()) {
            case 'payload':
              if (reader.w3x().equals(Token_NULL_getInstance())) {
                reader.v3x();
              } else {
                payloadResponse = parseResponse(reader, $operation, VOID, $customScalarAdapters, null);
              }

              break;
            case 'errors':
              if (reader.w3x().equals(Token_NULL_getInstance())) {
                reader.v3x();
              } else {
                errors = readErrors(reader);
              }

              break;
            default:
              reader.v3x();
              break;
          }
        }
        reader.g3y();
        var tmp_0;
        if (!(errors == null)) {
          tmp_0 = errorResponse(this$0, $operation, RouterError().j4e(errors));
        } else if (!(payloadResponse == null)) {
          tmp_0 = payloadResponse;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        if ($incrementalResultsMerger._v == null) {
          $incrementalResultsMerger._v = this$0.s65_1.l64();
        }
        var merged = $incrementalResultsMerger._v.w64(value);
        var deferredFragmentIdentifiers = $incrementalResultsMerger._v.t64();
        var isLast = !$incrementalResultsMerger._v.u64();
        var tmp_1;
        if ($incrementalResultsMerger._v.v64()) {
          tmp_1 = null;
        } else {
          tmp_1 = toApolloResponse(jsonReader(merged), $operation, VOID, $customScalarAdapters, deferredFragmentIdentifiers).j41().a42(isLast).i37();
        }
        tmp = tmp_1;
      }
      var tmp0_elvis_lhs_0 = tmp;
      var tmp_2;
      if (tmp0_elvis_lhs_0 == null) {
        break $l$block;
      } else {
        tmp_2 = tmp0_elvis_lhs_0;
      }
      var transformed = tmp_2;
      yield* tmp0.v1d(transformed, $completion);
    }
    return Unit_instance;
  }, 1);
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().d47('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().u41(operation, tmp0_requestUuid).z41(apolloException).a42(true).i37();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.p65_1) {
    tmp = httpResponse.j49();
  } else {
    var tmp0_safe_receiver = httpResponse.j49();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().d4e(httpResponse.e49_1, httpResponse.f49_1, maybeBody, 'Http request failed with status code `' + httpResponse.e49_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, request, customScalarAdapters, httpResponse) {
  var operation = request.s40_1;
  // Inline function 'kotlin.apply' call
  var this_0 = jsonReader_0(ensureNotNull(httpResponse.j49()));
  var tmp0_elvis_lhs = request.e41_1;
  this_0.q4c(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
  var response = toApolloResponse(this_0, operation, VOID, customScalarAdapters, null).j41().v41(httpResponse.i49_1).a42(true).i37();
  return flowOf(response);
}
function multipleResponses($this, request, customScalarAdapters, httpResponse) {
  var incrementalResultsMerger = {_v: null};
  var operation = request.s40_1;
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, request, customScalarAdapters, $this, incrementalResultsMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().d47('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.j41().c40(requestUuid);
  if (!(httpResponse == null)) {
    this_0.v41(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.e49_1, httpResponse.f49_1));
  }
  return this_0.i37();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.u65_1 = $outer;
      }
      *i65(request, chain, $completion) {
        return yield* this.u65_1.n65_1.d65(request, $completion);
      }
    }
    protoOf($).sz = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.h61_1 = null;
        this.i61_1 = null;
        this.j61_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.k61_1 = ArrayList().p2();
        this.l61_1 = false;
        this.m61_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.n61_1 = ArrayList().p2();
      }
      o61(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.i61_1 = serverUrl;
        return this;
      }
      q61(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.l61_1 = exposeErrorBody;
        return this;
      }
      p61(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.j61_1 = httpEngine;
        return this;
      }
      r61(interceptors) {
        // Inline function 'kotlin.apply' call
        this.k61_1.a5();
        this.k61_1.u2(interceptors);
        return this;
      }
      i37() {
        // Inline function 'kotlin.check' call
        if (!(this.h61_1 == null || this.i61_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.h61_1;
        var composer = tmp0_elvis_lhs == null ? DefaultHttpRequestComposer().f48(this.i61_1) : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.n61_1.n1()) {
          this.k61_1.i2(new (TransportHeadersInterceptor())(this.n61_1));
        }
        var tmp1_elvis_lhs = this.j61_1;
        return new (HttpNetworkTransport())(composer, tmp1_elvis_lhs == null ? DefaultHttpEngine() : tmp1_elvis_lhs, this.k61_1, this.l61_1, this.m61_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.v65_1 = headers;
      }
      *i65(request, chain, $completion) {
        return yield* chain.l65(request.q49().o48(this.v65_1).i37(), $completion);
      }
    }
    protoOf($).sz = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.w65_1 = function_0;
      }
      *v1d(value, $completion) {
        return yield* this.w65_1(value, $completion);
      }
      i5() {
        return this.w65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.x65_1 = function_0;
      }
      *v1d(value, $completion) {
        return yield* this.x65_1(value, $completion);
      }
      i5() {
        return this.x65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$1$$inlined$map$1Class;
function HttpNetworkTransport$execute$1$$inlined$map$1() {
  if (HttpNetworkTransport$execute$1$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.y65_1 = $this;
        this.z65_1 = this$0;
        this.a66_1 = $request;
        this.b66_1 = $httpResponse;
        this.c66_1 = $millisStart;
      }
      *u1d(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda(collector, this.z65_1, this.a66_1, this.b66_1, this.c66_1);
        yield* this.y65_1.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$1$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$1$$inlined$map$1Class;
}
function HttpNetworkTransport$execute$slambda(this$0, $httpRequest, $request, $customScalarAdapters) {
  return constructCallableReference(function *($this$flow, $completion) {
    var millisStart = currentTimeMillis();
    var throwable = null;
    var tmp;
    try {
      tmp = yield* (new (DefaultHttpInterceptorChain())(this$0.t65_1, 0)).l65($httpRequest, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        if (t instanceof CancellationException()) {
          throw t;
        }
        throwable = t;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var httpResponse = tmp;
    var tmp_1;
    if (httpResponse == null) {
      tmp_1 = flowOf(errorResponse(this$0, $request.s40_1, ensureNotNull(throwable)));
    } else {
      var tmp_2;
      var containsArg = httpResponse.e49_1;
      if (!(200 <= containsArg ? containsArg <= 299 : false)) {
        tmp_2 = !get_isGraphQLResponse(httpResponse);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = errorResponse_0(this$0, $request.s40_1, httpResponse);
      } else {
        if (get_isMultipart(httpResponse)) {
          tmp_1 = multipleResponses(this$0, $request, $customScalarAdapters, httpResponse);
        } else {
          tmp_1 = singleResponse(this$0, $request, $customScalarAdapters, httpResponse);
        }
      }
    }
    var responses = tmp_1;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var tmp$ret$0 = new (HttpNetworkTransport$execute$1$$inlined$map$1())(responses, this$0, $request, httpResponse, millisStart);
    yield* emitAll($this$flow, tmp$ret$0, $completion);
    return Unit_instance;
  }, 1);
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
        this.d66_1 = $this;
        this.e66_1 = $operation;
        this.f66_1 = $request;
        this.g66_1 = $customScalarAdapters;
        this.h66_1 = this$0;
        this.i66_1 = $incrementalResultsMerger;
      }
      *u1d(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda(collector, this.e66_1, this.f66_1, this.g66_1, this.h66_1, this.i66_1);
        yield* this.d66_1.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      y1c(collector, $completion) {
        return this.u1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
function HttpNetworkTransport$multipleResponses$slambda($operation, this$0) {
  return constructCallableReference(function *($this$catch, throwable, $completion) {
    yield* $this$catch.v1d(Builder().u41($operation, uuid4()).z41(wrapIfNeeded(this$0, throwable)).i37(), $completion);
    return Unit_instance;
  }, 2);
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody, incrementalDeliveryProtocol) {
        this.m65_1 = httpRequestComposer;
        this.n65_1 = engine;
        this.o65_1 = interceptors;
        this.p65_1 = exposeErrorBody;
        this.q65_1 = incrementalDeliveryProtocol;
        this.r65_1 = new (EngineInterceptor())(this);
        this.s65_1 = get_impl(this.q65_1);
        this.t65_1 = plus(this.o65_1, this.r65_1);
      }
      v62(request) {
        var customScalarAdapters = ensureNotNull(request.w40_1.s45(Key_getInstance()));
        var tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs = request.z40_1;
        var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (equals_0(element.w48_1, 'accept', true)) {
              tmp$ret$1 = false;
              break $l$block_0;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          var tmp_1;
          var tmp_2 = request.s40_1;
          if (isInterface(tmp_2, Subscription())) {
            tmp_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp_1 = this.s65_1.k64();
          }
          var accept = tmp_1;
          tmp = request.j41().i40('accept', accept).i37();
        } else {
          tmp = request;
        }
        var request_0 = tmp;
        var httpRequest = this.m65_1.g48(request_0);
        return this.j66(request_0, httpRequest, customScalarAdapters);
      }
      j66(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda(this, httpRequest, request, customScalarAdapters));
      }
      sz() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.o65_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.sz();
        }
        this.n65_1.l6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
